<!--All articles for topic-->
<div class="ui padded text container">
  <h2 class="ui header">
    <div class="header">
      {{ article | i18nSelect:'title':'englishTitle' }}
      @if (article?.isDraft) {
        <span class="ui yellow label" i18n="@@article-draft">Entwurf</span>
      }
      <!--CLICK TO ADD TO FAV-->
      @if (article && user?.favArticles?.includes($any(article._id))) {
        <i class="yellow favorite icon active"
           (click)="removeArticleFromFavorites()"
           (keydown)="removeArticleFromFavorites()"
           tabindex="-1"
           suiPopup popupText="Artikel aus Lesezeichen entfernen!"
           i18n-popupText="@@articles-remove-bookmark"
        ></i>
      } @else {
        <i class="favorite icon active"
           (click)="addArticleToFavorites()"
           (keydown)="addArticleToFavorites()"
           tabindex="-1"
           suiPopup popupText="Artikel zu Lesezeichen hinzufügen!"
           i18n-popupText="@@articles-add-bookmark"
        ></i>
      }
      @if (user && article && (user | canEdit:article:userRoles)) {
        <a class="ui right floated secondary button" [routerLink]="['/author/articles/edit', article._id]"
           i18n="@@articles-edit">
          <i class="edit icon"></i>
          Bearbeiten
        </a>
      }
    </div>
    @if (userRoles?.includes(clientRoles.IS_AUTHOR)) {
      <div class="sub header" i18n="@@articles-edited">Erstellt/Bearbeitet am: {{ article?.updatedAt | date }}</div>
    }
    @if (article?.permanentFlag) {
      <div class="sub header" i18n="@@articles-no-deadline">
        Kein Fristablauf!
      </div>
    } @else if (article?.validDate) {
      <div class="sub header" i18n="@@articles-deadline">
        Fristablauf: {{ article?.validDate | date }}
      </div>
    }
    <div class="sub header">
      <ul class="ui relaxed bulleted list">
        @for (deadline of article?.deadlines; track deadline) {
          <li class="item" i18n="@@articles-until">{{ deadline | i18nSelect:'title':'englishTitle' }} bis zum {{ deadline.date | date}}</li>
        }
      </ul>
    </div>
    <div class="sub header" i18n="@@articles-categories">
      Kategorien:
      @for (topic of article?.topics; track topic._id) {
        <a routerLink="/articles" [queryParams]="{topics: topic._id}">{{ topic | i18nSelect:'name':'englishName' }}</a>
        @if (!$last) {, }
      }
    </div>
  </h2>
  <div class="ui divider"></div>
  <div class="ui segment">
    <div [innerHTML]="article | i18nSelect:'description':'englishDescription'">
    </div>
    <div class="ui divider"></div>
    <div class="extra">
      <div class="sub header">Links:</div>
      <ul class="ui relaxed bulleted list">
        @for (link of article?.links; track link) {
          <li class="item">
            <a [href]="link.url" target="_blank" rel="noopener noreferrer">
              {{ link.label || link.url }}
            </a>
          </li>
        }
      </ul>
      @if (article?.englishLinks?.length) {
        <div class="sub header">Links to english version:</div>
        <ul class="ui relaxed bulleted list">
          @for (link of article?.englishLinks; track link) {
            <li class="item">
              <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                <i class="us flag"></i>
                {{ link.label || link.url }}
              </a>
            </li>
          }
        </ul>
      }
    </div>
  </div>
</div>
